module.exports = __webpack_public_path__ + "static/media/icon_user.441606f9.svg";